// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

export interface ProviderAppEnvConfig {
  medplumBaseUrl?: string;
  medplumClientId?: string;
  medplumOrganizationId?: string;
  insuranceDeferredBillingEnabled?: boolean;
  /**
   * Polaris environment this app is running in (dev-<handle>, e2e, preview-<pr>,
   * staging, production). Phase 1 of the environment-isolation plan exposes this
   * value but does not yet use it for routing or data scoping — see
   * docs/ENVIRONMENT_ISOLATION_PLAN.md.
   */
  polarisEnv?: string;
  schedulingEngine: SchedulingEngine;
  stripePublishableKey?: string;
  supportEmail?: string;
  providerAppBaseUrl?: string;
}

export type SchedulingEngine = 'legacy' | 'medplum-v2';

export function parseSchedulingEngine(value: string | undefined | null): SchedulingEngine {
  const engine = value?.trim() || 'medplum-v2';
  if (engine === 'medplum-v2') {
    return engine;
  }

  throw new Error(`Invalid VITE_SCHEDULING_ENGINE: ${value}. Only medplum-v2 is supported.`);
}

export function getProviderAppEnvConfig(): ProviderAppEnvConfig {
  return {
    medplumBaseUrl: import.meta.env?.VITE_MEDPLUM_BASE_URL,
    medplumClientId: import.meta.env?.VITE_MEDPLUM_CLIENT_ID,
    medplumOrganizationId: import.meta.env?.VITE_MEDPLUM_ORGANIZATION_ID,
    insuranceDeferredBillingEnabled: import.meta.env?.VITE_PATIENT_APP_INSURANCE_DEFERRED_BILLING_ENABLED === 'true',
    polarisEnv: import.meta.env?.VITE_POLARIS_ENV,
    schedulingEngine: parseSchedulingEngine(import.meta.env?.VITE_SCHEDULING_ENGINE),
    stripePublishableKey: import.meta.env?.VITE_STRIPE_PUBLISHABLE_KEY ?? import.meta.env?.STRIPE_PUBLISHABLE_KEY,
    supportEmail: import.meta.env?.VITE_SUPPORT_EMAIL,
    providerAppBaseUrl: import.meta.env?.VITE_PROVIDER_APP_BASE_URL,
  };
}
